module.exports = __webpack_public_path__ + "img/pic-4-1.e5377e25.png";